module.exports = __webpack_public_path__ + "static/media/profile.ef0701d3.jpg";